import Vue from 'vue'
import GetTextPlugin from 'vue-gettext'
import translations from '@/assets/translations.json'

Vue.use(GetTextPlugin, {
    availableLanguages: {
        en: 'English',
        nl: 'Dutch',
    },
    defaultLanguage: 'en',
    translations: translations,
})
